import * as PropTypes from 'prop-types';
import styled from 'styled-components';
import { width, height, display, direction, alignContent, alignItems, alignSelf, justifyContent, flexGrow, flexNone, flexShrink, position, maxWidth, minWidth, maxHeight, minHeight, backgroundColor } from './boxStyle.helper';
import { rangeWithoutZero, union, mapping } from './transform.helper';
var marginTop = rangeWithoutZero('marginTop');
var marginRight = rangeWithoutZero('marginRight');
var marginBottom = rangeWithoutZero('marginBottom');
var marginLeft = rangeWithoutZero('marginLeft');
var margin = union(marginTop, marginBottom, marginLeft, marginRight);
var paddingX = rangeWithoutZero('paddingX');
var paddingY = rangeWithoutZero('paddingY');
var padding = union(paddingX, paddingY);
var propToStyleFn = {
  color: backgroundColor,
  display: mapping({
    none: display('none'),
    flex: display('flex'),
    block: display('block'),
    inlineBlock: display('inline-block'),
    inlineFlex: display('inline-flex')
  }),
  direction: direction,
  flex: mapping({
    grow: flexGrow,
    none: flexNone,
    shrink: flexShrink
  }),
  justifyContent: mapping({
    end: justifyContent('flex-end'),
    center: justifyContent('center'),
    between: justifyContent('space-between'),
    around: justifyContent('space-around')
  }),
  alignContent: alignContent,
  alignItems: alignItems,
  alignSelf: alignSelf,
  width: width,
  maxWidth: maxWidth,
  minWidth: minWidth,
  height: height,
  maxHeight: maxHeight,
  minHeight: minHeight,
  margin: margin,
  marginTop: marginTop,
  marginRight: marginRight,
  marginBottom: marginBottom,
  marginLeft: marginLeft,
  padding: padding,
  paddingX: paddingX,
  paddingY: paddingY,
  position: position
};
var MarginPropType = PropTypes.oneOf([-12, -11, -10, -9, -8, -7, -6, -5, -4, -3, -2, -1, 0, 1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12]);
var PaddingPropType = PropTypes.oneOf([0, 1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12]);
export var Box = styled.div.attrs({
  'data-id': function dataId(props) {
    return props['data-id'] || 'box';
  },
  style: function style(_ref) {
    var dangerouslySetInlineStyle = _ref.dangerouslySetInlineStyle;
    return dangerouslySetInlineStyle && dangerouslySetInlineStyle.__style ? dangerouslySetInlineStyle.__style : {};
  }
}).withConfig({
  displayName: "Box",
  componentId: "sc-1b0qmmy-0"
})(["box-sizing:border-box;&:focus{outline:0;}", ";"], function (props) {
  var c = [];

  for (var prop in props) {
    if (Object.prototype.hasOwnProperty.call(propToStyleFn, prop)) {
      var fn = propToStyleFn[prop];
      var value = props[prop];
      c = c.concat(fn(value));
    }
  }

  return c;
});
Box.propTypes = {
  color: PropTypes.oneOf(['redPink', 'red', 'orange', 'lightOrange', 'lightBlue', 'grey', 'lightGrey', 'blue', 'green', 'lightGreen', 'purple', 'grey4', 'grey8', 'grey16', 'grey24', 'grey48', 'grey80', 'grey56', 'white', 'transparent']),
  position: PropTypes.oneOf(['static', 'absolute', 'relative', 'fixed']),
  display: PropTypes.oneOf(['none', 'flex', 'block', 'inlineBlock', 'inlineFlex']),
  direction: PropTypes.oneOf(['row', 'column']),
  flex: PropTypes.oneOf(['grow', 'shrink', 'none']),
  alignContent: PropTypes.oneOf(['flex-start', 'flex-end', 'center', 'between', 'around', 'stretch']),
  alignItems: PropTypes.oneOf(['flex-start', 'flex-end', 'center', 'baseline', 'stretch']),
  alignSelf: PropTypes.oneOf(['auto', 'flex-start', 'flex-end', 'center', 'baseline', 'stretch']),
  justifyContent: PropTypes.oneOf(['start', 'end', 'center', 'between', 'around']),
  margin: MarginPropType,
  marginTop: MarginPropType,
  marginRight: MarginPropType,
  marginBottom: MarginPropType,
  marginLeft: MarginPropType,
  maxHeight: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
  maxWidth: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
  minHeight: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
  minWidth: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
  padding: PaddingPropType,
  paddingX: PaddingPropType,
  paddingY: PaddingPropType,
  width: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
  height: PropTypes.oneOfType([PropTypes.number, PropTypes.string])
};